export const getIdFromNodeId = (nodeId: string): number => {
  return parseInt(atob(nodeId).substring(atob(nodeId).lastIndexOf('i') + 1));
};

export default getIdFromNodeId;
